import {
  StyledButton,
  StyledButtonText,
  StyledImg,
} from "Components/Error/ErrorStyles";
import { UnauthenticatedLayout } from "Components/Layout/UnauthenticatedLayout";
import { RecentActivities } from "Components/Shared/Icons";
import * as React from "react";
import { Resources, useResource } from "Translations/Resources";

export const ApplicationError: React.FunctionComponent = _ => {
  const { t } = useResource();

  const refresh = () => {
    window.location.href = "/";
  };

  return (
    <UnauthenticatedLayout
      title={t(Resources.Errors.ApplicationError.Title)}
      subTitle={t(Resources.Errors.ApplicationError.Subtitle)}
      image={
        <StyledImg>
          <RecentActivities />
        </StyledImg>
      }
      btn={
        <StyledButton onClick={refresh}>
          <StyledButtonText>{t(Resources.Dashboard.Title)}</StyledButtonText>
        </StyledButton>
      }
    ></UnauthenticatedLayout>
  );
};
